// source:
// system/application/views/special_pages/business_card_promotion.php
// system/application/views/special_pages/feedback_promotion.php
// system/application/views/special_pages/unsubscribe.php
$(() => {
    const $promo = $('#promocode');
    const placeholder = 'Enter Your Promotion Code Here';

    $promo
        .on('focus', function () {
            if (this.value === placeholder) {
                this.value = '';
                this.className = 'big-input-focus';
            }
        })
        .on('blur', function () {
            if (this.value === '') {
                this.value = placeholder;
                this.className = 'big-input';
            }
        });
});
